export default "__VITE_ASSET__BhbE6PCu__"